import React from 'react';
import { Alert } from '@mui/material';

/**
 * Единообразный способ показать пользователю, что запрос не удался,
 * вместо тихого console.error и пустого списка.
 */
const ErrorNotice = ({ children, sx }) => {
  if (!children) return null;
  return (
    <Alert severity="error" sx={{ my: 2, ...sx }}>
      {children}
    </Alert>
  );
};

export default ErrorNotice;
